module.exports = __webpack_public_path__ + "static/media/2.5459c1a6.png";